import { Extension } from '@tiptap/core';
import { PluginKey, Plugin } from '@tiptap/pm/state';
import { ContextualMenuPluginKey } from '../ContextualMenu/ContextualMenuPlugin.js';

const VirtualCursorPlugKey = new PluginKey("fakeVirtualCursor");
const VirtualCursorPlugin = (target = () => document.body) => {
  return new Plugin({
    key: VirtualCursorPlugKey,
    view(view) {
      const dom = view.dom;
      let focused = false;
      const cursor = document.createElement("div");
      cursor.dataset.tiptapVirtualCursor = "true";
      cursor.style.visibility = "hidden";
      cursor.style.width = `1px`;
      cursor.style.height = "1.5em";
      cursor.style.display = "inline-block";
      cursor.style.backgroundColor = "var(--fabric-color-text-primary)";
      cursor.style.position = "fixed";
      cursor.style.pointerEvents = "none";
      cursor.style.zIndex = "125";
      cursor.style.animation = "cursor-blink 1s steps(2, start) infinite";
      target().appendChild(cursor);
      const update = () => {
        const state = VirtualCursorPlugKey.getState(view.state);
        const selection = view.state.selection;
        if (!selection || focused || !state?.pos) {
          cursor.style.visibility = "hidden";
          return;
        }
        const { from } = selection;
        const htmlNode = view.domAtPos(from).node;
        const targetElement = htmlNode instanceof HTMLElement ? htmlNode : htmlNode.parentElement;
        if (targetElement) {
          const computedStyle = getComputedStyle(targetElement);
          const fontSize = computedStyle.fontSize;
          cursor.style.height = `calc(${fontSize} * 1.2)`;
        }
        const rect = view.coordsAtPos(from);
        cursor.style.visibility = "visible";
        cursor.style.left = `${rect.left}px`;
        cursor.style.top = `${rect.top}px`;
      };
      const observer = new ResizeObserver(() => update);
      observer.observe(cursor);
      update();
      const onFocus = () => {
        focused = true;
        update();
      };
      const onBlur = () => {
        focused = false;
        update();
      };
      dom.addEventListener("focus", onFocus);
      dom.addEventListener("blur", onBlur);
      window.addEventListener("scroll", update, {
        passive: false,
        capture: true
      });
      return {
        destroy: () => {
          observer.disconnect();
          cursor.remove();
          dom.removeEventListener("focus", onFocus);
          dom.removeEventListener("blur", onBlur);
          window.removeEventListener("scroll", update, {
            passive: false,
            capture: true
          });
        },
        update: () => {
          update();
        }
      };
    },
    state: {
      init() {
        return {
          pos: null
        };
      },
      apply(tr, oldState, newState) {
        const contextualMenu = ContextualMenuPluginKey.getState(newState);
        if (!contextualMenu?.active) {
          return {
            pos: null
          };
        }
        if (!tr.selectionSet && !!oldState.pos) return oldState;
        return {
          pos: newState.selection.from
        };
      }
    }
  });
};
const VirtualCursorExtension = Extension.create({
  name: "virtualCursor",
  addOptions: () => ({
    target: () => document.body
  }),
  addProseMirrorPlugins() {
    return [
      VirtualCursorPlugin(this.options.target)
    ];
  }
});

export { VirtualCursorExtension, VirtualCursorPlugKey, VirtualCursorPlugin };
//# sourceMappingURL=VirtualCursor.js.map
